import {DataProvider, HttpError} from "@refinedev/core";
import axios from "axios";


// Error handling with axios interceptors
const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
    (response) => { return response; },
    (error) => {
        const customError: HttpError = {
            ...error,
            message: error.response?.data?.message,
            statusCode: error.response?.status
        }
        return Promise.reject(customError);
    }
)


export const dataProvider = (apiUrl: string): DataProvider => ({
    // create
    create: async ({ resource, variables }) => {
        // console.log('create', resource, variables)
        const url = `${apiUrl}/${resource}`;
        const { data } = await axiosInstance.post(url, variables);
        return { data };
    },

    // Get list
    getList: async ({ resource, filters, meta }): Promise<any> => {
        // console.log('getList', resource, filters, meta)
        const url = `${apiUrl}/${resource}`;
        const { data } = await axiosInstance.get(url);
        return {data: meta?.resourceName ? data[meta.resourceName] : data};
    },

    // updates
    update: async ({ resource, id, variables }) => {
        // console.log('update', resource, id, variables)
        const url = `${apiUrl}/${resource}/${id}`;
        const { data } = await axiosInstance.put(url, variables);
        return { data };
    },

    // deleteOne
    deleteOne: async ({ resource, id, variables }) => {
        // console.log('deleteOne', resource, id, variables)
        const url = `${apiUrl}/${resource}/${id}`;
        const { data } = await axiosInstance.delete(url, { data: variables });
        return { data };
    },

    // getOne
    getOne: async ({ resource, id }) => {
        // console.log('getOne', resource, id)
        const url = `${apiUrl}/${resource}/${id}`;
        const { data } = await axiosInstance.get(url);
        return { data };
    },

    getApiUrl: () => {
        // console.log('getApiUrl')
        return apiUrl
    }

})